import { render, staticRenderFns } from "./AvisoSelf.vue?vue&type=template&id=65316c76&"
import script from "./AvisoSelf.vue?vue&type=script&lang=js&"
export * from "./AvisoSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports